import { render, staticRenderFns } from "./StripeIdentityModal.vue?vue&type=template&id=7dda07b1"
import script from "./StripeIdentityModal.vue?vue&type=script&lang=js"
export * from "./StripeIdentityModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports